module.exports = __webpack_public_path__ + "media/images/logos/logo-nav-2140c802fd8e58ec811bdfea87ef3462.png";